/**
 * Joins multiple class names into a single string, filtering out any falsy values.
 * @param classes - An array of class names, which can be strings, undefined, boolean, or null.
 * @returns A string containing all truthy class names separated by spaces.
 *
 * @example
 * joinClassNames("card", isActive && "active"); // "card active" if isActive is true
 * joinClassNames("card", "active"); // "card active"
 */
export const joinClassNames = (
  ...classes: (string | undefined | boolean | null)[]
) => classes.filter(Boolean).join(" ");
